import { makeAutoObservable } from 'mobx';
import VideoService from '../services/VideoService';
import DateService from '../services/DateService';
const isDev = process.env.NODE_ENV !== 'production';

class VideoListStore {
    loading = true;
    error = false;
    videoList = [];
    page = 1;
    buttonLoading = false;
    countryCode = '';
    trackedAt = '';
    onlyNew = false;
    hasMorePages = true;
    totalPages = 0;

    constructor() {
        makeAutoObservable(this);
        this.initFromUrl();
    }

    initFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const countryCodeParam = params.get('countryCode');
        const trackedAtParam = params.get('trackedAt');
        const onlyNewParam = params.get('onlyNew');

        if (countryCodeParam) {
            this.setCountryCode(countryCodeParam);
        }

        trackedAtParam
            ? this.setTrackedAt(trackedAtParam)
            : this.setTrackedAt(DateService.getTodayFormatedDate());

        if (onlyNewParam !== null) {
            this.setOnlyNew(true);
        }
    }

    fetchVideoList() {
        this.setLoading(true);
        this.setError(false);

        VideoService.getVideoList(this.page, this.countryCode, this.trackedAt, this.onlyNew)
            .then(response => {
                this.setVideoList(response.items);
                // Немедленно скрываем кнопку, если получили пустой ответ
                if (response.items.length === 0) {
                    this.setHasMorePages(false);
                }
                this.setPaginationInfo(response.pagination, response.items.length);
            })
            .catch(() => {
                this.setError(true);
            })
            .finally(() => {
                this.setLoading(false);
            })
    }

    loadMoreVideoList() {
        this.setButtonLoading(true);

        VideoService.getVideoList(this.page, this.countryCode, this.trackedAt, this.onlyNew)
            .then(response => {
                this.mergeVideoList(response.items);
                // Немедленно скрываем кнопку, если пришло 0 элементов
                if (response.items.length === 0) {
                    this.setHasMorePages(false);
                }
                this.setPaginationInfo(response.pagination, response.items.length);
            })
            .catch(() => {
                this.setError(true);
            })
            .finally(() => {
                this.setButtonLoading(false);
            });
    }

    setVideoList(items) {
        this.videoList = items;
    }

    mergeVideoList(items) {
        this.videoList = [...this.videoList, ...items];
    }

    setError(bool) {
        this.error = bool;
    }

    setLoading(bool) {
        this.loading = bool;
    }

    setPage(number) {
        this.page = number;
    }

    setButtonLoading(bool) {
        this.buttonLoading = bool;
    }

    setHasMorePages(bool) {
        this.hasMorePages = bool;
        // Принудительно обновляем MobX
        this.videoList = [...this.videoList];
    }

    setCountryCode(string) {
        this.countryCode = string;
        this.resetPagination();
        this.videoList = [];
    }

    setTrackedAt(string) {
        this.trackedAt = string;
        this.resetPagination();
        this.videoList = [];
    }

    setOnlyNew(bool) {
        this.onlyNew = bool;
        this.resetPagination();
        this.videoList = [];
    }

    setPaginationInfo(pagination, receivedItemsCount = undefined) {
        if (pagination && typeof pagination.totalPages === 'number') {
            this.totalPages = pagination.totalPages;
            const currentPageFromApi = typeof pagination.page === 'number' ? pagination.page : this.page;
            const limitFromApi = typeof pagination.limit === 'number' ? pagination.limit : 25;
            const itemsCount = typeof receivedItemsCount === 'number' ? receivedItemsCount : 0;

            const isLastPageByIndex = currentPageFromApi >= this.totalPages;
            const isLastPageByCount = itemsCount < limitFromApi; // если пришло меньше лимита — это последняя страница

            this.setHasMorePages(!(isLastPageByIndex || isLastPageByCount || itemsCount === 0));
        } else {
            // Fallback: если нет информации о пагинации, 
            // скрываем кнопку если в текущем ответе меньше элементов чем ожидается
            const expectedItemsPerPage = 25; // лимит по умолчанию из API
            const currentPageItems = typeof receivedItemsCount === 'number' ? receivedItemsCount : this.videoList.length;
            
            // Если элементов меньше ожидаемого количества, значит это последняя страница
            this.setHasMorePages(currentPageItems >= expectedItemsPerPage);
        }
    }

    resetPagination() {
        this.page = 1;
        this.setHasMorePages(true);
        this.totalPages = 0;
    }
}

const videoListStore = new VideoListStore();
export default videoListStore;